import { HttpParams } from '@angular/common/http';
import { Guid } from 'guid-typescript';
import { BudgetPlan } from './submission';
import { AllocationAction, AllocationStateMachine } from '../states/allocation.machine';
import { AllocationStatus } from '../enums/allocation-status';


export interface CreateAllocation {
  associationId: string;
  activityName: string;
  targetGroups?: string;
  amountRequestedFromMunicipality?: number;
  implementationStart?: Date;
  implementationEnd?: Date;
  activityDescription?: string;
  fieldOfOperation?: string;
  territorialCoverage?: string;
  volunteersInvolved?: boolean;
  potentialVolunteerCount?: number;
  justification?: string;
  organizationName?: string;
  address?: string;
  postalCodeAndHeadquarters?: string,
  county?: string;
  registrationNumber?: string;
  oib?: string;
  rno?: string;
  telephone?: string;
  fax?: string;
  organizationEmail?: string;
  website?: string;
  bankName?: string;
  bankAccountNumber?: string;
  projectLeader?: string;
  authorizedRepresentative?: string;
  fileStorageLocation?: string;
  budgetPlan: BudgetPlan;
}

export interface UpdateAllocation {
  id: Guid;
  activityName: string;
  targetGroups?: string;
  amountRequestedFromMunicipality?: number;
  implementationStart?: Date;
  implementationEnd?: Date;
  activityDescription?: string;
  fieldOfOperation?: string;
  territorialCoverage?: string;
  volunteersInvolved?: boolean;
  potentialVolunteerCount?: number;
  justification?: string;
  organizationName?: string;
  address?: string;
  postalCodeAndHeadquarters?: string,
  county?: string;
  registrationNumber?: string;
  oib?: string;
  rno?: string;
  telephone?: string;
  fax?: string;
  organizationEmail?: string;
  website?: string;
  bankName?: string;
  bankAccountNumber?: string;
  projectLeader?: string;
  authorizedRepresentative?: string;
  fileStorageLocation?: string;
  budgetPlan: BudgetPlan;
}

export interface Allocation {
  id: Guid;
  associationId: number;
  activityName: string;
  targetGroups?: string;
  amountRequestedFromMunicipality?: number;
  implementationStart?: Date;
  implementationEnd?: Date;
  activityDescription?: string;
  fieldOfOperation?: string;
  territorialCoverage?: string;
  volunteersInvolved?: boolean;
  potentialVolunteerCount?: number;
  justification?: string;
  organizationName?: string;
  address?: string;
  postalCodeAndHeadquarters?: string,
  county?: string;
  registrationNumber?: string;
  oib?: string;
  rno?: string;
  telephone?: string;
  fax?: string;
  organizationEmail?: string;
  website?: string;
  bankName?: string;
  bankAccountNumber?: string;
  projectLeader?: string;
  authorizedRepresentative?: string;
  fileStorageLocation?: string;
  status: AllocationStatus;
  createdAt: Date;
  submittedAt?: Date;
  approvedAt?: Date;
  rejectedAt?: Date;
  budgetPlan: BudgetPlan;
}

export class AllocationSummary {
  id: Guid;
  associationId: number;
  organizationName: string;
  activityName: string;
  status: AllocationStatus;
  amountRequestedFromMunicipality?: number;
  submittedAt: Date;


  constructor(
    id: Guid,
    associationId: number,
    organizationName: string,
    activityName: string,
    status: AllocationStatus,
    submittedAt: Date,
    amountRequestedFromMunicipality?: number
  ) {
    this.id = id;
    this.associationId = associationId;
    this.organizationName = organizationName;
    this.activityName = activityName;
    this.status = status;
    this.submittedAt = submittedAt;
    this.amountRequestedFromMunicipality = amountRequestedFromMunicipality;
  }


  get userFriendlyStatus(): string {
    switch (this.status) {
      case AllocationStatus.Draft:
        return 'Skica';
      case AllocationStatus.Submitted:
        return 'Izravna dodjela predana';
      case AllocationStatus.Returned:
        return 'Izravna dodjela vraćena na doradu';
      case AllocationStatus.Resubmitted:
        return 'Izravna dodjela ponovno predana';
      case AllocationStatus.Approved:
        return 'Izravna dodjela odobrena';
      case AllocationStatus.Rejected:
        return 'Izravna dodjela odbijena';
      default:
        return 'Nepoznato';
    }
  }

  isActionAllowed(action: AllocationAction): boolean {
    return AllocationStateMachine.can(action, this.status);
  }

    static fromJson(data: any): AllocationSummary {
        return new AllocationSummary(
          Guid.parse(data.id),
          data.associationId,
          data.organizationName,
          data.activityName,
          data.status,
          data.submittedAt,
          data.amountRequestedFromMunicipality
        );
      }

}

export class GetAllocationsFilter {
  constructor(
    public municipalityId?: string | null,
    public associationId?: string | null,
    public status?: AllocationStatus | null,
    public year?: number | null
  ) {}

  toQueryParams(): HttpParams {
    let params = new HttpParams();
    
    if (this.municipalityId) {
      params = params.set('municipalityId', this.municipalityId);
    }
    
    if (this.associationId) {
      params = params.set('associationId', this.associationId);
    }
    
    if (this.status !== null && this.status !== undefined) {
      params = params.set('status', this.status.toString());
    }
    
    if (this.year !== null && this.year !== undefined) {
      params = params.set('year', this.year.toString());
    }
    
    return params;
  }
}

export enum AllocationFormType {
  B1 = 1,
  B2 = 2
}
